










































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Timestamp, UserResp } from '@/apiv3/index'
import auth from '@/auth'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import helpers from '@/helpers'
import VueUploadComponent from 'vue-upload-component'

@Component({ components: { PulseLoader, VueUploadComponent } })
export default class UserEdit extends Vue {
  @Prop(String) id!: string

  public user!: UserResp
  public blocked = false
  public loaded = false

  mounted () {
    const id = helpers.getAmount(this.id)
    auth.adminClient().User({ id: BigInt(id) }).then((resp) => {
      this.user = resp
      this.loaded = true
    })
  }

  formatDate (val: Timestamp | undefined): string {
    return helpers.formatDateTs(val)
  }
}
